import IconButton from "../ui-components/IconButton";
import {PaperClipIcon} from "@heroicons/react/24/solid";
import {useRef, useContext, useState} from "react";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import CountryContext from "../CountryContext";
import axios from "axios";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { NotificationsContext } from "../ui-components/Notifications";

const re = /(?:\.([^.]+))?$/;
const ACCEPTED_FORMATS = [
  "image/*",
  "application/pdf",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
];

const NotesAttachementsUploader = ({
                                       worksiteId,
                                       maxSize = 5120,
                                       noteAttachments,
                                       setNoteAttachments,
                                       attachmentsBeingUploadedProgresses,
                                       setattachmentsBeingUploadedProgresses,
                                   }
) => {
    const hiddenAttachmentInputRef = useRef(null);
    const { push } = useContext(NotificationsContext);
    const checkUploadedAttachment = (file) => {

        let error = null;
        const format = re.exec(file.name)[1];

        if (!format)
            error = file.name + " has unknown file format";

        if (maxSize) {
            const size = file.size;
            const kb = Math.round(size / 1024);
            if (maxSize < kb)
                error = file.name + " is too big";
        }

        return {format, error};
    }

    const apiRequest = useCountryAxiosInstance();
    const { country } = useContext(CountryContext);

    const uploadAttachment = async (file, format, indexOfAttachementBeingUploaded, existingAttachemntUrl) => {

        const {url, fields} = await apiRequest.post(`/aws-signed-url`, {
            content_type: file.type,
            format: format,
            prefix: `attachments/${country.code}/worksites_notes/${worksiteId}`,  // won't be used if existingImageUrl is given
            bucket: "worksites_notes_attachments",
            method: "POST",
            fileUrl: existingAttachemntUrl
        });
        const formData = new FormData();
        Object.keys(fields).map((key) => {
            return formData.append(key, fields[key]);
        });
        // Actual file has to be appended last.
        formData.append("file", file);

        // --- upload image to s3
        // onUploadStart();
        const options = {
            headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
                "Cache-Control": "max-age=31536000",
            },
            onUploadProgress: (progressEvent) => {
                const progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                setattachmentsBeingUploadedProgresses((attachmentsBeingUploadedProgresses) => {
                    let tmp = [...attachmentsBeingUploadedProgresses];
                    tmp[indexOfAttachementBeingUploaded].progress = progress;
                    return tmp;
                });
            },
        };
        try {
            await axios.post(url, formData, options);
        } catch (error) {
            console.log(error);
            push({
                title: "Something went wrong",
                type: "error",
            });
            return {error: "Something went wrong"};
        }
        return {attachment_url: url + fields.key, filename: file.name, loadedOn: new Date()};
    }

    return (
        <div>
            <input
                ref={hiddenAttachmentInputRef}
                type="file"
                accept={ACCEPTED_FORMATS.join(",")}
                multiple
                style={{display: "none"}}
                onChange={async (e) => {

                    const filesToUploadwithFormats = []
                    for (let file of Object.values(e.target.files)) {
                        const {format, error} = checkUploadedAttachment(file);
                        if (error) {
                            push({title: error, type: "error"});
                        } else {
                            filesToUploadwithFormats.push({file, format})
                        }
                    }
                    const numberOfAttachmentsAlreadyBeingUploaded = attachmentsBeingUploadedProgresses.length;
                    setattachmentsBeingUploadedProgresses([...attachmentsBeingUploadedProgresses,
                        ...(filesToUploadwithFormats.map(({file, format}) => {
                            return {
                                filename:file.name,
                                progress:0
                            }
                        }))]);
                    let attachments = []
                    let index = 0
                    for (let {file , format} of filesToUploadwithFormats) {
                        let {
                            attachment_url,
                            filename,
                            loadedOn
                        } = await uploadAttachment(file,
                            format,
                            numberOfAttachmentsAlreadyBeingUploaded + index);
                        attachments.push({attachment_url, filename, loadedOn})
                        index++
                    }
                    setNoteAttachments([...noteAttachments, ...attachments]);
                    setattachmentsBeingUploadedProgresses([]);
                }}
            />
            <IconButton
                Icon={PaperClipIcon}
                className={"w-5 h-5"}
                onClick={() => {
                    hiddenAttachmentInputRef.current.click();
                }}
            />
        </div>);

}

export default NotesAttachementsUploader;